import React, { FunctionComponent } from 'react';

import { features } from 'components/lexemes';
import { AppLink } from 'lib/app/app-link';
import { CdnImagePath } from 'lib/cdn-image-path';
import LocaleContext from 'lib/locale-context';

import { onClickWhatsNewDateCta } from 'containers/events';

import PageSectionCta from 'components/page/sections/page-section-cta';

export const ComplimentsBlockTwoContainer: FunctionComponent = () => {
    const lang = React.useContext(LocaleContext);

    const imagePath = `${CdnImagePath}/bumble/l-assets/${lang}/features/Compliments-sendingacompliment.jpg`;

    const props = {
        imageSrc: imagePath,
        imageAlt: '',
        imageObjectPosition: '65% 10%',
        title: features.compliments.lxComplimentsTwoBlockTitle,
        text: features.compliments.lxComplimentsTwoBlockBodyText,
        actionText: features.compliments.lxComplimentsTwoBlockTitle,
        actionUrl: AppLink.BUMBLE_GET_STARTED,
    };

    return (
        <PageSectionCta
            title={props.title}
            text={props.text}
            action={{
                text: props.actionText,
                href: props.actionUrl,
                onClick: onClickWhatsNewDateCta,
            }}
            image={{
                src: props.imageSrc,
                objectPosition: props.imageObjectPosition,
            }}
            color="orange"
        />
    );
};
